import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddDatasource
    from '../../../../components/Erm/Actions/Properties/AddDatasource';
import { addDatasource } from '../../../../store/Erm/Entity/actionCreators';
import { setCloseGlobalModal } from '../../../../store/GlobalModal/actionCreators';

const mapStateToProps = (state: any, ownProps: any) => {
    const modal = state.globalModal;
    return {
        payload: modal && modal.payload ? modal.payload : {},
    };

};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            addDatasource,
            closeModal: () => {
                return setCloseGlobalModal();
            },
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddDatasource);
